import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import CartViewHeader from "./CartViewHeader";
import { elsevierStyleSheetJSfileImport } from "../library/utils";

const MainHeader = (props) => {
  const [cartProducts, setCartProducts] = useState([]);
  const [ariaExpanded, setAriaExpanded] = useState(false);
  const [ariaExpandedButton, setAriaExpandedButton] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [cartButton, setCartButton] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchCartDetails();
    getCustomerProfile();
    elsevierStyleSheetJSfileImport();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.cartUpdated) {
      fetchCartDetails();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.cartUpdated, cartProducts]);

  const fetchCartDetails = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const config = {
      method: "post",
      url: `${backendBookartUrl}/view_cart_details`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        setCartProducts(response.data.cart_details);
      })
      .catch((error) => {
        if (error.response && error.response.data.msg === 'Token has expired') {
          // Redirect to login page if the token has expired
          navigate('/');
        } else {
          console.log(error);
        }
      });
  };

  const deleteCartItem = (cartId, productId) => {
    const emailId = window.sessionStorage.getItem("emailId");
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      useremailaddress: emailId,
      cart_id: cartId,
      product_id: productId,
    });

    const config = {
      method: "post",
      url: `${backendBookartUrl}/remove_cart_details?=`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setCartProducts(response.data.cart_details);
        if (typeof props.fetchCartAfterModifying === "function") {
          props.fetchCartAfterModifying(); // Update Parent Component view after Deleting.
        }
      })
      .catch((error) => {
        if (error.response && error.response.data.msg === 'Token has expired') {
          // Redirect to login page if the token has expired
          navigate('/');
        } else {
          console.log(error);
        }
      });
  };

  const pushToAccountDetails = (event) => {
    event.preventDefault();
    navigate("/accountDetails");
  };

  const toggleMobile = () => {
    setAriaExpanded(!ariaExpanded);
  };

  const signOut = () => {
    window.sessionStorage.removeItem("JWTtoken");
    navigate("/");
  };

  const getCustomerProfile = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const config = {
      method: "post",
      url: `${backendBookartUrl}/accountdetails?=`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        setAccountDetails(response.data.account_details[0]);
      })
      .catch((error) => {
        if (error.response && error.response.data.msg === 'Token has expired') {
          // Redirect to login page if the token has expired
          navigate('/');
        } else {
          console.log(error);
        }
      });
  };

  const cartButtonToggle = () => {
    setCartButton(!cartButton);
  };

  const handleAccountButton = () => {
    setAriaExpandedButton(!ariaExpandedButton);
  };

  return (
    <React.Fragment>
      <header className="es-header es-js-header header">
        <div className="es-header-product es-js-product">
          <Link to="/home">
            <img
              alt="Elsevier"
              className="es-header-product-logo"
              height="80"
              src="/ElsevierStyleSheet/images/nonsolus.svg"
              width="73"
            />
            <div className="bookart-logo">BooKart</div>
          </Link>
        </div>

        <ul className="es-header-links es-js-links">
          <li>
            <Link to="/home" className="es-link">
              Home
            </Link>
          </li>
          <li>
            <Link to="/list" className="es-link">
              All Books
            </Link>
          </li>
          <li>
            <Link className="es-link" to="/instantOrder">
              Instant Order
            </Link>
          </li>
          <li>
            <Link className="es-link" to="/orderHistory">
              Order History
            </Link>
          </li>
          <li>
            <Link className="es-link" to="/support">
              Support
            </Link>
          </li>
        </ul>

        <ul className="es-header-icons es-js-icons">
          <li
            className="es-header-icons-item es-header-icons-mobile svg"
            onClick={cartButtonToggle}
          >
            <button
              aria-controls="es-id-header-cart"
              aria-label="Cart"
              className="es-header-icons-button es-js-tooltip es-js-popup"
              aria-expanded={cartButton}
            >
              <svg viewBox="0 0 126 128" height="24" width="24">
                <path d="M43.994 18l1.342 9.98h67.757c-.979 6-3.016 19.327-7.243 46.428-.647 4.14-4.695 7.592-8.84 7.592H52.122c-4.162 0-8.285-3.49-8.824-7.502-6.481-48.214-7.005-52.221-7.02-52.332C34.922 13.124 26.695 6 17.55 6H1v10h16.55c4.1 0 8.23 3.612 8.825 7.578 0 0 .508 3.843 7.012 52.224C34.587 84.735 42.99 92 52.122 92H97.01c9.088 0 17.311-7.03 18.72-16.055C124.466 19.923 123.746 24 124.781 18zm-2.992 82a10 10 0 1 0 0 20 10 10 0 1 0 0-20zM103 100a10.002 10.002 0 1 0 0 20.004A10.002 10.002 0 1 0 103 100z" />
              </svg>
              {cartProducts.length !== 0 ? (
                <div className="cart-badge">
                  {cartProducts.length}
                </div>
              ) : null}
            </button>
            <div
              className="es-popup below medium"
              hidden={!cartButton}
              id="es-id-header-cart"
            >
              <div className="es-popup-content">
                <CartViewHeader
                  data={cartProducts}
                  deleteCartItem={deleteCartItem}
                />
              </div>
              <button
                aria-label="Close popup"
                className="es-popup-close es-js-popup-close"
                onClick={cartButtonToggle}
              >
                <svg viewBox="0 0 70 128" height="24" width="14">
                  <path d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
                </svg>
              </button>
            </div>
          </li>
          <li className="es-header-icons-item background">
            <button
              aria-controls="es-id-header-profile"
              aria-label="Profile"
              className="es-header-icons-button round es-js-tooltip es-js-popup"
              onClick={handleAccountButton}
              aria-expanded={ariaExpandedButton}
            >
              {window.sessionStorage.getItem("emailId").substring(0, 2)}
            </button>
            <div
              className="es-popup below small"
              hidden={!ariaExpandedButton}
              id="es-id-header-profile"
            >
              <div className="es-popup-content">
                <div className="es-header-user">
                  <div className="es-header-banner">
                    <div className="es-header-banner-icon round">
                      {window.sessionStorage.getItem("emailId").substring(0, 2)}
                    </div>
                    <div className="es-header-banner-name">
                     {accountDetails.individual_name}
                      <br />
                     {accountDetails.email_address}
                    </div>
                  </div>
                </div>
                <div className="es-header-buttons">
                  <button
                    className="es-button secondary"
                    onClick={pushToAccountDetails}
                  >
                    <span>Account Details</span>
                  </button>
                  <button
                    className="es-button primary"
                    onClick={signOut}
                  >
                    <span>Sign out</span>
                  </button>
                </div>
              </div>
              <button
                aria-label="Close popup"
                className="es-popup-close es-js-popup-close"
                onClick={handleAccountButton}
              >
                <svg viewBox="0 0 70 128" height="24" width="14">
                  <path d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
                </svg>
              </button>
            </div>
          </li>
          <li className="es-header-icons-item es-header-icons-mobile">
            <button
              aria-controls="es-id-header-side"
              aria-label="More"
              onClick={toggleMobile}
              className="es-header-icons-button es-js-tooltip es-js-popup"
              aria-expanded={ariaExpanded}
            >
              <svg viewBox="0 0 40 24" height="24" width="40">
                <path d="M0 18h40v2H0zm0-7h40v2H0zm0-7h40v2H0z" />
              </svg>
            </button>
          </li>
        </ul>
        <div
          aria-label="Account, links and setting"
          className="es-header-side es-js-sidebar"
          hidden={!ariaExpanded}
          id="es-id-header-side"
          role="dialog"
        >
          <div className="es-header-side-content">
            <svg
              className="pointer right-float"
              onClick={toggleMobile}
              viewBox="0 0 70 128"
              height="24"
              width="14"
            >
              <path d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
            </svg>
            <div className="es-header-user">
              <div className="es-header-banner">
                <div className="es-header-banner-icon round">
                  {window.sessionStorage.getItem("emailId").substring(0, 2)}
                </div>
                <div className="es-header-banner-name">
                  {accountDetails.individual_name}
                  <br />
                  {accountDetails.email_address}
                </div>
              </div>
              <div className="es-header-banner-action">
                <Link to="/accountDetails" className="es-link colored">
                  Account Details
                </Link>
                <button className="es-link colored" onClick={signOut}>
                  Sign out
                </button>
              </div>
            </div>
            <ul className="es-header-links es-js-links navigation-mobile">
              <li>
                <Link to="/home" className="es-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/list" className="es-link">
                  All Books
                </Link>
              </li>
              <li>
                <Link to="/instantOrder" className="es-link">
                  Instant Order
                </Link>
              </li>
              <li>
                <Link to="/orderHistory" className="es-link">
                  Order History
                </Link>
              </li>
              <li>
                <Link to="/support" className="es-link">
                  Support
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default MainHeader;